export enum RuleType {
    Property = 1,
    All = 2
}
